<template>
    <div class="c-title mt-3">
        <div :class="tag">{{label}}</div>
        <p v-if="description !== ''" class="text-muted">{{description}}</p>
        <hr/>
    </div>
</template>

<script>
  export default {
      name: 'Title',
      components: {
      },
      props: {
          label: {
              type: String,
              default: ''
          },
          description: {
              type: String,
              default: ''
          },
          tag: {
              type: String,
              default: 'h1'
          },
      },
      watch: {
      },
      mounted() {
      },
      data: () => {
          return {
          }
      },
      methods: {
      }
  }
</script>